import { CounterMedium } from '../automationObjects/Devices/CounterMedium';
import { CounterType } from '../automationObjects/Devices/CounterType';
import { CustomThemeT } from '../theme/customTheme'

export function addAlpha(color: string, opacity: number): string {
  // coerce values so ti is between 0 and 1.
  const _opacity = Math.round(Math.min(Math.max(opacity, 0), 1) * 255);
  return color + ("0" + _opacity.toString(16)).slice(-2).toUpperCase();
}

export function getMeasurmentColor(dimension: string, theme: CustomThemeT): string {

  const dimensionToColorMap = {
    '°C': theme.appColors.measurments.temperature,
    '°F': theme.appColors.measurments.temperature,
    '°K': theme.appColors.measurments.temperature,
    '%rF': theme.appColors.measurments.humidity,
    '%': theme.appColors.measurments.humidity,
    'Pa': theme.appColors.measurments.airPressure,
    'pa': theme.appColors.measurments.airPressure,
    'bar': theme.appColors.measurments.pressure,
    'm³': theme.appColors.measurments.airVolume,
    'm³/h': theme.appColors.measurments.airVolume,
    'kWh': theme.appColors.measurments.energy,
    'MWh': theme.appColors.measurments.energy,
    'lux': theme.appColors.measurments.brightness,
    'lx': theme.appColors.measurments.brightness,
    'klx': theme.appColors.measurments.brightness,
    'kW': "#FF6937",
    'W': "#FF6937",
    'default': theme.appColors.measurments.default,
  } as IDictionary

  const tmp = dimensionToColorMap[dimension || 'default'];
  return tmp ?? dimensionToColorMap['default'];
}

export function getMediumColor(medium: CounterMedium, type: CounterType, theme: CustomThemeT): string {

  if (medium === CounterMedium.ElectricityMeter && type === CounterType.FeedOut)
    return theme.colors.positive600;

  if (type === CounterType.Producer)
    return theme.colors.positive300;

  const mediumToColorMap = {
    [CounterMedium.ElectricityMeter]: theme.appColors.medium.electricity,
    [CounterMedium.HeatMeter]: theme.appColors.medium.heat,
    [CounterMedium.ColdMeter]: theme.appColors.medium.cold,
    [CounterMedium.WaterMeter]: theme.appColors.medium.water,
    [CounterMedium.GasMeter]: theme.appColors.medium.gas,
    [CounterMedium.FuelMeter]: theme.appColors.medium.fuel,
    99: theme.appColors.medium.default,
  } as IDictionary


  const tmp = mediumToColorMap[medium];
  return tmp ?? mediumToColorMap[99];
}

interface IDictionary {
  [index: number]: any;
}

export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
